export type ProcessOfferEmailsTranslation = {
  column: {
    date: string;
    from: string;
    status: string;
    subject: string;
    to: string;
  };
  empty: string;
  indicator: {
    inEmail: string;
    inEmailDraft: string;
    notInEmail: string;
    tooltipAttached: string;
    tooltipDraftOnly: string;
    tooltipNotAttached: string;
  };
  noSubject: string;
  preview: {
    attachments: string;
    cc: string;
    close: string;
    date: string;
    from: string;
    noSubject: string;
    status: string;
    statusDraft: string;
    statusSent: string;
    to: string;
  };
  status: {
    draft: string;
    sent: string;
  };
  title: string;
};

export const processOfferEmailsTranslation: ProcessOfferEmailsTranslation = {
  column: {
    date: 'Data',
    from: 'Od',
    status: 'Status',
    subject: 'Tytuł',
    to: 'Do',
  },
  empty: 'Ta oferta nie została jeszcze dołączona do żadnego maila.',
  indicator: {
    inEmail: 'W mailu',
    inEmailDraft: 'Szkic w mailu',
    notInEmail: 'Brak w mailu',
    tooltipAttached: 'Oferta dołączona do maili — kliknij aby zobaczyć',
    tooltipDraftOnly: 'Oferta jest tylko w szkicach maili — jeszcze nie została wysłana',
    tooltipNotAttached: 'Oferta nie została jeszcze nigdzie dołączona',
  },
  noSubject: '(bez tytułu)',
  preview: {
    attachments: 'Załączniki',
    cc: 'DW',
    close: 'Zamknij',
    date: 'Data',
    from: 'Od',
    noSubject: '(bez tytułu)',
    status: 'Status',
    statusDraft: 'Szkic',
    statusSent: 'Wysłany',
    to: 'Do',
  },
  status: {
    draft: 'Wersja robocza',
    sent: 'Wysłany',
  },
  title: 'Maile',
};
